/**
 * Utility for shortening the visible breadcrumbs on a view.
 */
const breadcrumbShortener = function () {
	let breadcrumbs = $('.breadcrumbs'),
		breadcrumbsNotCurrent = breadcrumbs.find('li:not(.current)');
	if (breadcrumbsNotCurrent.length === 6) {
		breadcrumbs.addClass('hasSixChild bcactive')
			.find('.separation:eq(4)').addClass('activeDot');
	} else if (breadcrumbsNotCurrent.length === 5) {
		breadcrumbs.addClass('hasFiveChild bcactive')
			.find('.separation:eq(3)').addClass('activeDot');
	} else if (breadcrumbsNotCurrent.length === 4) {
		breadcrumbs.addClass('hasFourChild bcactive')
			.find('.separation:eq(2)').addClass('activeDot');
	} else if (breadcrumbsNotCurrent.length === 3) {
		breadcrumbs.addClass('hasThreeChild bcactive')
			.find('.separation:eq(1)').addClass('activeDot');
	} else if (breadcrumbsNotCurrent.length === 2) {
		breadcrumbs.addClass('hasTwoChild bcactive')
			.find('.separation:eq(0)').addClass('activeDot');
	} else if (breadcrumbsNotCurrent.length === 1) {
		breadcrumbs.addClass('hasOneChild bcactive');
	}

	// Shorten breadcrumbs Toggle
	if (breadcrumbs.length > 0) {
		breadcrumbs.find('.separation').click(function () {
			breadcrumbs.toggleClass('active')
				.find('.separation.activeDot').toggleClass('activeAgain');
		});
	}
};

export default breadcrumbShortener;
